import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_SECURITIES_ACCOUNT_EDIT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_SECURITIES_ACCOUNT_EDIT_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_SECURITIES_ACCOUNT_EDIT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/stock-accounts/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
